import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { FacebookIcon, LinkIcon, InstagramIcon, LinkedinIcon, EmailIcon } from '@domain-group/fe-co-icon';
import { AgentAwardPill } from '@domain-group/fe-co-allhomes-shared-components';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './agent-card-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentCardHeader = props => {
  var _props$highlightedAwa, _props$highlightedAwa2;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var mobile = props.media.mobile;
  var socialIcon = (Icon, target, eventName) => target ? ___EmotionJSX("a", {
    href: target,
    onClick: () => sendEvent("social.".concat(eventName, "-click")),
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": eventName
  }, ___EmotionJSX("div", {
    css: styles.socialIcon
  }, ___EmotionJSX(Icon, null))) : undefined;
  var handleEmailClick = () => {
    sendEvent('email-click');
    props.onEmailClick();
  };
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: props.profilePhoto,
    imageTitle: props.name,
    shape: "circle",
    colorScheme: "dark"
  }), mobile ? ___EmotionJSX(Fragment, null, ___EmotionJSX("h1", {
    css: styles.name
  }, props.name), props.jobTitle && ___EmotionJSX("h2", {
    css: styles.jobTitle
  }, props.jobTitle)) : ___EmotionJSX(Fragment, null, ___EmotionJSX("h2", {
    css: styles.name
  }, props.name), props.jobTitle && ___EmotionJSX("h3", {
    css: styles.jobTitle
  }, props.jobTitle)), ((_props$highlightedAwa = props.highlightedAwards) === null || _props$highlightedAwa === void 0 ? void 0 : _props$highlightedAwa.length) > 0 && ((_props$highlightedAwa2 = props.highlightedAwards) === null || _props$highlightedAwa2 === void 0 ? void 0 : _props$highlightedAwa2.map(award => ___EmotionJSX(AgentAwardPill, {
    label: award.badgeLabel
  }))), ___EmotionJSX("div", {
    css: styles.socials
  }, socialIcon(LinkIcon, props.websiteUrl, 'website'), socialIcon(FacebookIcon, props.facebookUrl, 'facebook'), socialIcon(InstagramIcon, props.instagramUrl, 'instagram'), socialIcon(LinkedinIcon, props.linkedinUrl, 'linkedin')), mobile ? ___EmotionJSX("div", {
    css: styles.agencyDetailsContainer
  }, ___EmotionJSX("div", {
    css: styles.divider
  }), ___EmotionJSX("div", {
    css: styles.agencyInfoBox
  }, props.agencyLogo && ___EmotionJSX("a", {
    href: props.agencyProfileUrl,
    onClick: () => sendEvent('agency-logo-click')
  }, ___EmotionJSX("div", {
    css: styles.agencyLogoBox(props.agencyLogoBackgroundColour)
  }, ___EmotionJSX("img", {
    css: styles.agencyLogo,
    src: props.agencyLogo,
    alt: "Agency Logo",
    "data-test-id": "agency-logo"
  }))), ___EmotionJSX("h1", {
    css: styles.agencyName
  }, props.title), ___EmotionJSX("div", null, ___EmotionJSX("a", {
    css: styles.agencyProfileLink,
    href: props.agencyProfileUrl
  }, "View agency profile")))) : ___EmotionJSX("div", {
    css: styles.buttonGroupContainer
  }, ___EmotionJSX("div", {
    css: styles.buttonGroup,
    "data-test-id": "button-group"
  }, ___EmotionJSX(CallButton, {
    phone: props.phoneNumber
  }), props.isEmailContactable && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    appearance: "primary",
    css: styles.emailButton,
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: handleEmailClick
  }, "Email")))));
};
AllhomesAgentCardHeader.propTypes = {
  name: PropTypes.string.isRequired,
  profilePhoto: PropTypes.string,
  agencyLogo: PropTypes.string,
  agencyLogoBackgroundColour: PropTypes.string,
  jobTitle: PropTypes.string,
  // title is actually agency name:
  title: PropTypes.string,
  // Commented out because it'll be coming back soon
  // address: PropTypes.shape(Address.propTypes),
  websiteUrl: PropTypes.string,
  phoneNumber: PropTypes.string,
  isEmailContactable: PropTypes.bool,
  agencyProfileUrl: PropTypes.string,
  facebookUrl: PropTypes.string,
  instagramUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  onEmailClick: PropTypes.func.isRequired,
  highlightedAwards: PropTypes.arrayOf(PropTypes.shape({
    badgeLabel: PropTypes.string.isRequired
  })),
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool
  })
};
AllhomesAgentCardHeader.defaultProps = {
  profilePhoto: '',
  agencyLogo: undefined,
  agencyLogoBackgroundColour: undefined,
  title: undefined,
  jobTitle: '',
  // address: null,
  websiteUrl: '',
  phoneNumber: '',
  isEmailContactable: true,
  agencyProfileUrl: '',
  highlightedAwards: [],
  media: {},
  facebookUrl: undefined,
  instagramUrl: undefined,
  linkedinUrl: undefined
};
export default withMedia(AllhomesAgentCardHeader);
export { AllhomesAgentCardHeader as BaseAllhomesAgentCardHeader };